import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumber, { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { isString } from 'lodash-es';

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(val?: string, region?: CountryCode): string {
    return toPhone(val, region);
  }
}

export const toPhone = (val?: string, region: CountryCode = 'US'): string => {
  if (!isString(val)) {
    return '';
  }

  const phoneNumber = isValidPhoneNumber(val, region) ? parsePhoneNumber(val, region) : undefined;

  return phoneNumber ? `+${phoneNumber.countryCallingCode} ${phoneNumber.formatNational()}` : val;
};
